import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/App.css'; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo-section">
            <div className="footer-logo">
              <img src="../images/logowhite.png" alt="Talali Lodge Logo" className="footer-logo-image" />              
            </div>
           
          </div>
          
          <div className="footer-grid">
            <div className="footer-col">
              <h4>Contact Information</h4>
              <div className="footer-contact">
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <div>
                    <p>Along Area 9 Mosque Street, Lilongwe</p>
                    <p className="postal">P.O. Box 1912, Lilongwe</p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📧</span>
                  <div>
                    <a href="mailto:reservations@talalilodge.com" className="contact-link">
                      reservations@talalilodge.com
                    </a>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📱</span>
                  <div>
                    <a href="tel:+265892569952" className="contact-link">
                      +265 892 569 952
                    </a>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">🌐</span>
                  <div>
                    <a href="http://www.talalilodge.com" className="contact-link" target="_blank" rel="noopener noreferrer">
                      www.talalilodge.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/rooms">Rooms & Accommodation</Link></li>
                <li><Link to="/conference">Conference Facilities</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
            
            <div className="footer-col">
              <h4>Facilities</h4>
              <ul className="footer-links">
                <li>14 Comfortable Rooms</li>
                <li>Conference Room (60 pax)</li>
                <li>Free High-Speed WiFi</li>
                <li>24/7 Security</li>
                <li>Daily Housekeeping</li>
                <li>Secure Parking</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} Talali Lodge. All rights reserved.</p> 
            <p className="footer-address">Along Area 9 Mosque Street • P.O. Box 1912 • Lilongwe • Malawi</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;